import { Capacitor } from '@capacitor/core';
import MuseFlowMidi from 'Utils/MuseFlowMidiPlugin';
import type { NativeMidiDeviceState } from 'Utils/MuseFlowMidiPlugin';
import { ANDROID_BLUETOOTH_MIDI_PLUGIN, AndroidBluetoothMidi } from 'Utils/AndroidBluetoothMidi';

type MidiDeviceStateSource = { getMidiDeviceState(): Promise<NativeMidiDeviceState> };

const midiDeviceStateSource = (): MidiDeviceStateSource | null => {
  const platform = Capacitor.getPlatform();
  if (platform === 'ios' && Capacitor.isPluginAvailable('MuseFlowMidi')) return MuseFlowMidi;
  if (platform === 'android' && Capacitor.isPluginAvailable(ANDROID_BLUETOOTH_MIDI_PLUGIN)) {
    return AndroidBluetoothMidi;
  }
  return null;
};

/**
 * Asks the app which keyboards are connected now. The app also announces them
 * with `MIDIDevicesChanged`, but on a cold start that announcement can land
 * before the page has loaded and be lost, so the page asks once it is up.
 * Null in a browser, or in an app build from before the question existed.
 */
export const askNativeMidiDeviceState = async (): Promise<NativeMidiDeviceState | null> => {
  const source = midiDeviceStateSource();
  if (!source) return null;
  try {
    const state = await source.getMidiDeviceState();
    if (typeof state?.connected !== 'boolean') return null;
    return {
      connected: state.connected,
      sources: Array.isArray(state.sources) ? state.sources : [],
    };
  } catch {
    return null;
  }
};
